module.exports = __webpack_public_path__ + "files/SPIADI2026 - EXP ADI.21f3752bbd338d74f110cbd9b74f2d84.xlsx";